
import { Bot, Zap, Brain, BookOpen, Settings, FileText, Bookmark, Wrench } from 'lucide-react';
import { NavItem } from '../types';

const agentItems: NavItem[] = [
  {
    title: "Agents",
    icon: Bot,
    path: "/app/agents",
    requiredPermissions: ['agent.read'],
    children: [
      {
        title: "All Agents",
        path: "/app/agents",
        requiredPermissions: ['agent.read'],
      },
      {
        title: "Create Agent",
        path: "/app/agents/new",
        requiredPermissions: ['agent.create'],
      },
      {
        title: "Agent Analytics",
        path: "/app/agents/analytics",
        requiredPermissions: ['agent.read', 'analysis.read'],
      },
      {
        title: "Training",
        path: "/app/agents/training",
        requiredPermissions: ['training.read'],
      },
      {
        title: "Templates",
        path: "/app/templates",
        requiredPermissions: ['template.read'],
      },
      {
        title: "Knowledge Base",
        path: "/app/knowledge-base",
        requiredPermissions: ['knowledge.read'],
      },
      {
        title: "Memory",
        path: "/app/memory",
        requiredPermissions: ['memory.read'],
      },
      {
        title: "Knowledge",
        path: "/app/knowledge",
        requiredPermissions: ['knowledge.read'],
      },
      {
        title: "Tools",
        path: "/app/tools",
        requiredPermissions: ['tools.read'],
      },
    ],
  }
];

export default agentItems;
